import React, { Suspense, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import AppRouter from './pages/AppRouter';
import { HashRouter } from 'react-router-dom';
import persistentStore from './store/index';
import Loading from './components/common/loading/Loading';
import { QueryClient, QueryClientProvider } from 'react-query';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { getLocalStorageValues } from './constants/index';
import { PersistGate } from 'redux-persist/integration/react';
import { defaultQueryFn, defaultMutationFn, reactQueryConfig } from './constants/index';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import theme from 'themes/light-theme';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      ...reactQueryConfig,
    },
    mutations: {
      mutationFn: defaultMutationFn,
    },
  },
});
const App = () => {
  const { userName } = getLocalStorageValues();
  if (userName.token) axios.defaults.headers.common.Authorization = `bearer ${userName.token}`;
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    theme.fetchDataAndUpdateTheme().finally(() => {
      setLoading(false);
    });
    // Fetch data from API and update the theme
  }, []);

  if (loading) {
    return <Loading gap={50} />;
  }
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <Provider store={persistentStore().store}>
          <PersistGate loading={null} persistor={persistentStore().persistor}>
            <Suspense fallback={<Loading gap={50} />}>
              <HashRouter>
                <AppRouter queryClient={queryClient} />
              </HashRouter>
            </Suspense>
          </PersistGate>
        </Provider>
      </QueryClientProvider>
    </I18nextProvider>
  );
};

export default App;
